import { render } from "./DonutChartCanvas.vue?vue&type=template&id=5e7b5c8c&scoped=true"
import script from "./DonutChartCanvas.vue?vue&type=script&lang=js"
export * from "./DonutChartCanvas.vue?vue&type=script&lang=js"

import "./DonutChartCanvas.vue?vue&type=style&index=0&id=5e7b5c8c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7b5c8c"]])

export default __exports__